module.exports = __webpack_public_path__ + "img/box-skins-violet.1b5c69a6.png";